import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import type { NotesPropertiesAlertBody } from '../alertHover.types'
import { notesPropsStyles } from './NotesProperties.styles'

const NotesPropertiesBody: React.FC<{ body: NotesPropertiesAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) {
    return null
  }

  return (
    <Box sx={notesPropsStyles.root}>
      <Typography sx={notesPropsStyles.item}>
        {t('notesProps.notes', { count: body?.notes ?? 0 })}
      </Typography>

      <Typography sx={notesPropsStyles.item}>
        {t('notesProps.properties', { count: body?.properties ?? 0 })}
      </Typography>
    </Box>
  )
}

export default NotesPropertiesBody
